module.exports = __webpack_public_path__ + "static/trig_006-b2fbcca4af0015bc40876af901b0f7e5.webp";